import React, { useEffect, useState } from "react";
import styles from "./RSVP.module.css";
import { SubmitButton } from "../../../../components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";

const RsvpIcon = () => {
  return (
    <svg
      className={styles.svgIcon}
      viewBox="0 0 454 462"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_121_24880)">
        <path
          d="M303.643 231.395C303.643 304.286 303.464 377.177 303.844 450.069C303.888 459.327 301.633 462.021 292.299 461.976C198.891 461.614 105.482 461.659 12.0965 461.953C3.32068 461.976 -0.00655494 460.323 0.0157755 450.454C0.306071 304.309 0.306071 158.141 0.0157755 11.9735C-0.00655494 2.64704 2.44979 0.043773 11.7169 0.06641C105.125 0.405966 198.511 0.473877 291.919 -0.00150117C302.258 -0.0467753 303.888 3.30351 303.844 12.7205C303.464 85.6119 303.643 158.503 303.643 231.395ZM57.2933 101.775C67.0741 111.101 74.6664 118.73 82.7054 125.861C86.8365 129.528 87.8637 133.15 86.6355 138.628C84.2908 149.132 82.884 159.862 80.7849 172.267C91.9948 166.585 101.91 161.899 111.489 156.602C116.558 153.795 120.823 153.636 125.959 156.489C135.517 161.808 145.409 166.494 156.664 172.199C154.654 160.427 153.582 150.377 151.103 140.688C149.228 133.399 151.148 128.826 156.552 124.185C164.211 117.598 171.179 110.241 179.977 101.729C166.891 99.7827 156.418 97.768 145.833 96.7946C139.402 96.2061 136.187 93.1727 133.619 87.5587C129.354 78.2096 124.329 69.2 118.68 58.2211C112.851 69.6754 107.738 79.0698 103.272 88.7585C100.994 93.7386 97.8454 96.0929 92.5084 96.7267C81.6112 97.9717 70.8032 99.7827 57.2933 101.775ZM151.818 336.929C180.356 336.929 208.872 336.702 237.411 337.087C244.512 337.178 247.839 335.321 246.923 327.783C246.611 325.203 246.521 322.464 246.923 319.906C248.576 309.696 244.132 307.568 234.597 307.636C181.607 308.112 128.639 307.863 75.6489 307.885C56.6457 307.885 57.1593 307.931 56.6234 326.674C56.3778 335.457 59.3031 337.268 67.342 337.132C95.5007 336.634 123.659 336.929 151.818 336.929ZM132.748 375.344C113.521 375.344 94.2948 375.344 75.0683 375.344C56.6904 375.344 57.2263 375.366 56.6234 393.431C56.3108 402.554 59.3031 404.659 67.8556 404.568C108.519 404.138 149.205 404.614 189.891 404.297C210.882 404.138 208.269 409.096 208.962 384.376C209.185 376.612 206.17 375.095 199.315 375.208C177.118 375.57 154.944 375.344 132.748 375.344ZM114.37 269.425C129.912 269.425 145.499 268.995 161.018 269.606C168.878 269.9 171.871 267.342 170.777 259.51C170.419 256.929 170.419 254.213 170.777 251.632C171.982 242.872 168.678 240.042 159.79 240.223C132.033 240.789 104.254 240.427 76.4752 240.427C55.7302 240.427 55.9535 240.427 56.6904 261.819C56.8914 267.727 58.6332 269.606 64.3944 269.493C81.0529 269.221 97.7114 269.425 114.37 269.425ZM245.762 148.973C224.682 151.373 214.991 140.122 208.582 122.578C203.736 141.933 191.656 149.901 172.116 149.381C188.775 159.907 192.415 173.829 184.912 192.3C194.558 187.818 201.593 181.955 208.582 182.001C215.973 182.046 223.32 187.728 232.878 191.916C225.866 173.919 228.3 159.839 245.762 148.973Z"
          fill={"var(--primary-color)"}
        />
        <path
          d="M341.547 455.272C341.547 440.694 341.547 426.116 341.547 411.538C341.547 312.749 341.547 213.984 341.547 115.196C341.547 102.655 341.592 102.61 353.337 106.933C384.622 118.433 415.885 130.046 447.214 141.409C452.864 143.469 455.588 145.167 452.953 152.479C416.912 252.082 381.25 351.844 345.455 451.537C344.963 452.896 344.093 454.141 343.4 455.431C342.797 455.363 342.172 455.318 341.547 455.272Z"
          fill={"var(--primary-color)"}
        />
      </g>
      <defs>
        <clipPath id="clip0_121_24880">
          <rect width="454" height="462" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const RSVP = () => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(EventPlanningMiddleware.getRsvp(EventDetails?.id));
  }, []);

  return (
    <div className={styles.mainCont}>
      <div className={styles.imgDiv}>
        <RsvpIcon />
      </div>
      <div className={styles.btnDiv}>
        <SubmitButton
          title={`${RSVP ? "View" : "Create"} RSVP`}
          btnClass={styles.btn}
          onClick={() =>
            navigate(RSVP ? "/events/RSVPCelebrate" : "/events/RSVPDetails", {
              state: { headrTitle: "RSVP" },
            })
          }
          // onClick={() => setIsModalOpen(false)}
        />
      </div>
    </div>
  );
};

export default RSVP;
